import {Repository} from '@s-ui/domain'

/**
 * @interface
 * */
export class DraftRepository extends Repository {
  /**
   * @method
   * @return {Error}
   */
  ongoingDraft() {
    throw new Error('[DraftRepository#ongoingDraft] must be implemented')
  }

  /**
   * @method
   * @return {Error}
   */
  editDraft() {
    throw new Error('[DraftRepository#editDraft] must be implemented')
  }

  /**
   * @method
   * @return {Error}
   */
  publishDraft() {
    throw new Error('[DraftRepository#publishDraft] must be implemented')
  }

  /**
   * @method
   * @return {Error}
   */
  discardDraft() {
    throw new Error('[DraftRepository#discardDraft] must be implemented')
  }

  /**
   * @method
   * @return {Error}
   */
  uploadPhotoDraft() {
    throw new Error('[DraftRepository#uploadPhotoDraft] must be implemented')
  }

  /**
   * @method
   * @return {Error}
   */
  renewAd() {
    throw new Error('[DraftRepository#renewAd] must be implemented')
  }

  /**
   * @method
   * @return {Error}
   */
  getFreeAdsAvailable() {
    throw new Error('[DraftRepository#getFreeAdsAvailable] must be implemented')
  }

  /**
   * @method
   * @return {Error}
   */
  getAdIdByCategory() {
    throw new Error('[DraftRepository#getAdIdByCategory] must be implemented')
  }
}
